// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__uxgif","label":"Input_label__VKysk","invalid":"Input_invalid__eta94"};